<div>
  <form [formGroup]="generalAccountInfoForm" *ngIf="formLoaded">
    <ion-item>
      <ion-select [label]="'GENERAL.ACCOUNT_TYPE' | translate" formControlName="type" [disabled]="!editing">
        <ion-select-option value="Company">{{ 'GENERAL.COMPANY' | translate }}</ion-select-option>
        <ion-select-option value="Personal">{{ 'GENERAL.PERSONAL' | translate }}</ion-select-option>
        <ion-select-option value="School">{{ 'GENERAL.SCHOOL' | translate }}</ion-select-option>
        <ion-select-option value="College / University">{{ 'GENERAL.COLLEGE_UNIVERSITY' | translate }}</ion-select-option>
        <ion-select-option value="School District">{{ 'GENERAL.SCHOOL_DISTRICT' | translate }}</ion-select-option>
        <ion-select-option value="Free" *ngIf="type === 'Free'">{{ 'GENERAL.FREE' | translate }}</ion-select-option>
        <ion-select-option value="Trial" *ngIf="type === 'Trial'" [disabled]="true">{{ 'GENERAL.TRIAL' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item *ngIf="type === 'Free' && canAdminister">
      <ion-label>{{ 'GENERAL.UPGRADE_TO_TRIAL' | translate }}</ion-label>
      <ion-button 
        slot="end" 
        color="primary" 
        (click)="upgradeToTrial()"
        [disabled]="updatePending">
        {{ 'GENERAL.UPGRADE' | translate }}
      </ion-button>
    </ion-item>
    
    <ion-item >
      <ion-input [label]="'GENERAL.NUMBER_OF_KILNS' | translate" class="ion-text-right" [readonly]="!editing" formControlName="numberControllers"></ion-input>
    </ion-item>

    <ion-item>
      <ion-input disabled="true" type="date" format="MMM dd, yyyy" [label]="'GENERAL.EXPIRATION' | translate" *ngIf="expiration" [class.danger]="isExpired" [value]="expiration"></ion-input>
      <ion-input disabled="true" [label]="'GENERAL.EXPIRATION' | translate" *ngIf="!expiration">{{ 'GENERAL.NOT_AVAILABLE' | translate }}</ion-input>
    </ion-item>

    <ion-item>
      <ion-select [label]="'GENERAL.TIME_ZONE' | translate" formControlName="timezone" [class.invalid]="generalAccountInfoForm && generalAccountInfoForm.controls.timezone.valid && generalAccountInfoForm.controls.timezone.touched" [disabled]="!editing">
        <ion-select-option class="default-us-timezone" *ngFor="let zone of getTopUSTimezones()" [value]="zone">{{zone}}</ion-select-option>
        <ion-select-option *ngFor="let zone of getTimezones()" [value]="zone">{{zone}}</ion-select-option>
      </ion-select>
    </ion-item>  
    
      <!-- Language selector as a form field -->
    <ion-item class="language-item" button (click)="openLanguageSwitcher()" *ngIf="isToggleEnabled('internationalization')">
      <ion-label>{{ 'ACCOUNT_SETTINGS.LANGUAGE' | translate }}</ion-label>
      <div slot="end" class="language-display">
        <span class="language-flag">{{ currentLanguageInfo.flag }}</span>
        <span class="language-name">{{ currentLanguageInfo.name }}</span>
        <ion-icon name="chevron-forward" color="medium"></ion-icon>
      </div>
    </ion-item>

    <ion-item *ngIf="isToggleEnabled('freeToPremium') && type === 'Free'">
      <ion-label>{{ 'GENERAL.START_SUBSCRIPTION' | translate }}</ion-label>
      <ion-button slot="end" color="primary" (click)="startSubscription()">
        {{ 'GENERAL.START_SUBSCRIPTION' | translate }}
      </ion-button>
    </ion-item>
    <ion-item *ngIf="isToggleEnabled('freeToPremium') && !payment && type !== 'Free' && !editing">
      <ion-label>{{ 'GENERAL.ADD_PAYMENT' | translate }}</ion-label>
      <ion-button slot="end" color="primary" (click)="startEditing(true)">
        {{ 'GENERAL.ADD_PAYMENT' | translate }}
      </ion-button>
    </ion-item>
    <ion-item *ngIf="isToggleEnabled('freeToPremium') && (payment || editing)" class="cost-per-year-item">
      <ion-label>{{ 'GENERAL.COST_PER_YEAR' | translate }} $19.99/year</ion-label>
    </ion-item>
    <ion-item *ngIf="isToggleEnabled('freeToPremium') && (payment || editing)">
      <app-account-payment #paymentsForm (startEdit)="startEditing(true)" slot="end"
        [accountInformation]="accountInformation" [canAdminister]="canAdminister" [editing]="editing">
      </app-account-payment>
    </ion-item>
  </form>  

  <ion-row class="general-actions ion-justify-content-end ion-padding-end">
    <ion-button size="small" *ngIf="canAdminister" color="light" (click)="delete()">{{ 'GENERAL.DELETE' | translate }}</ion-button>
    <ion-button size="small" *ngIf="canAdminister && !editing" color="secondary" (click)="startEditing()">{{ 'GENERAL.EDIT' | translate }}</ion-button>
    <ion-button size="small" *ngIf="canAdminister && editing" color="secondary" (click)="cancelEditing()">{{ 'GENERAL.CANCEL' | translate }}</ion-button>
    <ion-button size="small" type="submit"
      [disabled]="!isValid() || !canAdminister"
      (click)="save()" *ngIf="!updatePending">{{ 'GENERAL.SUBMIT' | translate }}</ion-button>
    <div *ngIf="updatePending" class="submitpending">
      <ion-spinner name='bubbles'></ion-spinner>
      <span>{{ 'GENERAL.UPDATING' | translate }}</span>
    </div>
  </ion-row>

  <ion-row class="ion-justify-content-end ion-padding-end premium-row" *ngIf="trialAvailable() && !accountExpired() && type === 'Free'">
    <div class="premium-upgrade">
      <div class="premium-content">
        <ion-icon name="star-outline" class="premium-icon"></ion-icon>
        <div class="premium-text">
          <p class="premium-title">{{ 'USER_INFO.PREMIUM_FEATURES_AVAILABLE' | translate }}</p>
        </div>
      </div>
      <ion-button (click)="startTrial()" fill="solid" color="primary" class="premium-button">
        <ion-icon name="rocket-outline" slot="start"></ion-icon>
        {{ 'USER_INFO.START_TRIAL' | translate }}
      </ion-button>
    </div>
  </ion-row>

</div>
